<template>
  <div>
    <popper placement="right">
      <span role="button">
        <span v-if="vehicle.drivers.length > 0" class="add-driver-btn px-1">
          <i class="fa-solid fa-plus"></i>
        </span>
        <span v-else class="text-center text-success text-uppercase add-driver-btn">
          Dodaj kierowcę
        </span>
      </span>
      <template #content>
        <div style="width: 300px;">
          <label>
            Zawęź wyniki wpisując tekst:
            <input type="text" ref="driverSearchText" class="form-control" @input="filterDrivers">
          </label>
          <label class="d-block mt-2">
            Dodaj nowego kierowcę z listy:
            <select
              class="d-inline form-select"
              v-model="selectedDriverId"
              required
            >
              <option
                :value="null"
                selected
              >
                -- wybierz kierowcę --
              </option>
              <option v-for="driver in driversSelected" :key="driver" :value="driver.id">
                {{ driver.surname }} {{ driver.firstName}}
              </option>
            </select>
            <div class="text-center mt-3">
              <button class="btn btn-primary" @click="attachDriver()">
                Dodaj kierowcę
              </button>
            </div>
          </label>
        </div>
      </template>
    </popper>
  </div>
</template>

<script>
import Popper from 'vue3-popper'
import Swal from 'sweetalert2'
import axios from 'axios'
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'

export default {
  name: 'AttachDriver',
  components: { Popper },
  props: ['drivers', 'vehicle'],
  data () {
    return {
      selectedDriverId: null,
      driverSearchText: '',
      driversSelected: [],
      shortPlusIconVisible: false
    }
  },
  mounted () {
    this.driversSelected = this.drivers
  },
  methods: {
    filterDrivers () {
      var myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      }

      fetch(`${process.env.VUE_APP_API_BASE_URL}Driver`, requestOptions)
        .then(response => response.text())
        .then(result => {
          const parsedResult = JSON.parse(result)
          this.driversSelected = []
          parsedResult.forEach(a => {
            if (`${a.firstName} ${a.surname}`.toLowerCase().includes(this.$refs.driverSearchText.value.toLowerCase()) || `${a.surname} ${a.firstName}`.toLowerCase().includes(this.$refs.driverSearchText.value.toLowerCase())) {
              this.driversSelected.push(a)
            }
          })
        })
        .catch(error => console.log('error', error))
    },
    async attachDriver () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const postData = { driverIds: [this.selectedDriverId] }
      const driver = this.drivers.find(d => d.id === this.selectedDriverId)
      const vehicles = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle`, config)).data
      const alreadyAttached = vehicles.find(v => v.drivers.map(d => d.id).includes(this.selectedDriverId))

      let dialogResult = null

      if (alreadyAttached !== undefined) {
        dialogResult = await Swal.fire({
          title: `Kierowca ${driver.firstName} ${driver.surname} jest już przypięty do ciągnika ${alreadyAttached.plateNumber}. Czy chcesz przenieść go do ciągnika ${this.vehicle.plateNumber} ?`,
          icon: 'question',
          showConfirmButton: true,
          confirmButtonText: 'Tak',
          showCancelButton: true,
          cancelButtonText: 'Nie'
        })
      }

      if (alreadyAttached === undefined || dialogResult?.isConfirmed) {
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}Vehicle/Vehicle/${this.vehicle.id}/Driver`, postData, config)
        emitter.emit('vehicleChanged')
        emitter.emit(eventKinds.driverAttached, { driverId: driver.id, vehicleId: this.vehicle.id })
        await Swal.fire(`Dodano kierowcę ${driver.firstName} ${driver.surname} do ciągnika ${this.vehicle.plateNumber}`, '', 'success')
        this.shortPlusIconVisible = true
      }
    }
  }
}
</script>

<style scoped>
.add-driver-btn {
  transition: .4s;
  font-size: .6rem;
  text-decoration: underline;
}

.add-driver-btn:hover {
  font-weight: 700;
}
</style>
